import { useState } from "react";
import axiosService from "../../../../core/services/axios-service";
import { ApiRoutes } from "../../../../core/dictionary/api-url";
import ToastService from "../../../../core/services/toaster-service";

export default function AddNewResource({ onSuccess }) {
  const [form, setForm] = useState({
    title: null,
    description: null,
    file: null
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // New: handle file selection + validation (50 MB limit)
  const handleFileChange = (e) => {
    setError("");
    const file = e.target.files && e.target.files[0];
    if (!file) {
      setForm({ ...form, file: null });
      return;
    }

    const MAX_SIZE = 50 * 1024 * 1024; // 50 MB
    if (file.size > MAX_SIZE) {
      setError("File size should not exceed 50 MB.");
      setForm({ ...form, file: null });
      e.target.value = null;
      return;
    }

    // Optional: restrict to common upload types (pdf, video, audio, images)
    const allowedTypes = [
      "application/pdf",
      "video/mp4",
      "video/quicktime",
      "audio/mpeg",
      "audio/mp3",
      "image/png",
      "image/jpeg",
      "image/svg+xml",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ];
    if (!allowedTypes.some((t) => file.type === t || file.type.startsWith("video/") || file.type.startsWith("audio/") || file.type.startsWith("image/"))) {
      setError("Unsupported file type. Allowed: PDF, video, audio, image, doc.");
      setForm({ ...form, file: null });
      e.target.value = null;
      return;
    }

    setForm({ ...form, file });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      // Build FormData per API contract
      const fd = new FormData();
      fd.append("title", form.title || "");
      fd.append("description", form.description || "");
      if (form.file) fd.append("file", form.file);
        const headers = {
        "Content-Type": "multipart/form-data",
      };
      const res = await axiosService.post(ApiRoutes.ADD_RESOURCE, fd, { headers });
      if (res.data && (res.data.message.toUpperCase() === "Content uploaded.".toUpperCase())) {
        ToastService.success("Resource uploaded successfully.");
        if (onSuccess) onSuccess(res.data);
      } else {
        setError(res.data?.message || "Failed to upload resource.");
      }
    } catch (err) {
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="p-3">
        <div className="mb-3">
          <label className="form-label">Title</label>
          <input
            type="text"
            name="title"
            className="form-control"
            placeholder="Enter Title"
            value={form.title}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Description</label>
          <input
            type="text"
            name="description"
            className="form-control"
            placeholder="Enter resource description"
            value={form.description}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Upload File (PDF, MP4, etc.) — max 50 MB</label>
          <input
            type="file"
            name="file"
            accept="application/pdf,video/*,audio/*,image/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            className="form-control"
            onChange={handleFileChange}
          />
          <small className="text-muted">Allowed types: PDF, video, audio, images, DOC/DOCX. Max size: 50 MB.</small>
        </div>

        {error && <div className="text-danger mb-2">{error}</div>}
        <button type="submit" className="btn btn-gradient" disabled={loading}>
          {loading ? "Loading..." : "Add Resource"}
        </button>
      </form>
    </>
  );
}
